import { datadogRum } from '@datadog/browser-rum';
import { put, select } from 'redux-saga/effects';
import { ApplicationState } from '../..';
import { addError } from '../../../utils/Observability';
import { IUserState } from '../user/types';
import { initializeObservabilitySuccess, RcaKind } from './actions';
import { IObservalibilityState } from './types';
import { datadogLogs } from '@datadog/browser-logs';

export function* sendRcaLogsAc(action: {
  payload: {
    rcaKind: RcaKind;
    resourceId: string;
    resourceType: string;
  };
}) {
  const { rcaKind, resourceId, resourceType } = action.payload;

  yield datadogLogs.logger.info('rca', {
    rcaKind,
    resourceId,
    resourceType
  });
}

export function* setObservabilitySaga() {
  try {
    const currentUrl = window.location.href;
    const isExecutingLocal = currentUrl.includes('localhost');
    const enabled = process.env.REACT_APP_ENABLE_OBSERVABILITY === 'true';

    if (enabled && !isExecutingLocal) {
      const userState: IUserState = yield select(
        (state: ApplicationState) => state.user
      );

      const observabilityState: IObservalibilityState = yield select(
        (state: ApplicationState) => state.observability
      );

      if (userState.id !== '' && !observabilityState.initialized) {
        initializeObservability(userState.id);
        yield put(initializeObservabilitySuccess());
      }
    }
  } catch (err) {
    console.error('setObservabilitySaga', err);
  }
}

export function* errorObservabilitySaga({ error }: { error: Error }) {
  try {
    const observabilityState: IObservalibilityState = yield select(
      (state: ApplicationState) => state.observability
    );

    if (observabilityState.initialized) {
      yield addError(error);
    }
  } catch (err) {
    console.error('errorObservabilitySaga', err);
  }
}

function initializeObservability(userId: string) {
  datadogRum.init({
    applicationId: '0cd98d52-63c5-4b19-9923-2409ad06566a',
    clientToken: 'pub45a6560dac71a566a94ad6a69506b242',
    site: 'datadoghq.com',
    service: 'egerdau-web',
    env: process.env.REACT_APP_BASE_URL,
    sampleRate: 100,
    replaySampleRate: 100,
    premiumSampleRate: 0,
    trackInteractions: true,
    defaultPrivacyLevel: 'allow'
  });

  datadogRum.setUser({
    id: userId
    //name: userState.name,
    //email: userState.email,
  });
  datadogLogs.init({
    clientToken: 'pub45a6560dac71a566a94ad6a69506b242',
    site: 'datadoghq.com',
    service: 'egerdau-web',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    env: 'prod'
  });
  datadogLogs.setUser({
    id: userId
  });
}
